<template>
  <div class="table-component" :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
    <div class="my-5 row" style="text-align: center">
      <div class="col-lg-6">
        {{ $t(title) + " (" + Object.keys(data).length + ")" }}
      </div>
      <div class="col-lg-6">
        <router-link :to="pageUrl" v-if="pageUrl">{{
          $t("add") + " " + $t("to") + " " + $t(title)
        }}</router-link>
      </div>
    </div>
    <div class="table-responsive" style="text-align: center">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th scope="col" v-for="(item, index) in titles" :key="index">
              {{ $t(item) }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in data" :key="index">
            <td
              v-for="([key, value], index2) in Object.entries(item).filter(
                ([key]) => titles.includes(key)
              )"
              :key="index2"
            >
              {{ value }} <span style="display: none">{{ key }}</span>
            </td>
            <td v-if="pageUrl">
              <button class="btn btn-danger" @click="itemDelete(item.id)">
                {{ $t("delete") }}
              </button>
            </td>
            <td v-if="EditUrl != ''">
              <button class="btn btn-primary" @click="itemUpdate(item)">
                {{ $t("update") }}
              </button>
            </td>
            <td v-if="pageUrl">
              <button
                class="btn btn-success"
                @click="
                  showHide = 1;
                  shownItem = item;
                  socialShown =
                    item.social_media == undefined ? [] : item.social_media;
                "
              >
                {{ $t("show") }}
              </button>
            </td>
            <td v-if="!pageUrl">
              <button class="btn btn-success" @click="itemDelete(item.id)">
                {{ $t("change_status") }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="PopUp" id="popup" v-if="showHide">
      <div class="table-responsive p-5" style="margin-top: 100px">
        <table
          class="table table-striped table-hover"
          style="text-align: center"
        >
          <thead>
            <tr>
              <th
                scope="col"
                v-for="([key, value], index) in Object.entries(
                  shownItem
                ).filter(([key]) => !titlesNo.includes(key))"
                :key="index"
              >
                {{ $t(key) }} <span style="display: none">{{ value }}</span>
              </th>
              <th v-if="Object.keys(socialShown).length > 0">
                {{ $t("facebook") }}
              </th>
              <th v-if="Object.keys(socialShown).length > 0">
                {{ $t("skype") }}
              </th>
              <th v-if="Object.keys(socialShown).length > 0">
                {{ $t("instagram") }}
              </th>
              <th v-if="Object.keys(socialShown).length > 0">
                {{ $t("linkdin") }}
              </th>
              <th v-if="Object.keys(socialShown).length > 0">
                {{ $t("twitter") }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td
                v-for="([key, value], index) in Object.entries(
                  shownItem
                ).filter(([key]) => !titlesNo.includes(key))"
                :key="index"
              >
                <span v-html="value" v-if="key == 'icon'"></span>
                <img
                  v-else-if="key == 'img' || key == 'image'"
                  class="imageTable"
                  :src="$store.state.server + value"
                  alt=""
                />
                <span v-else>{{ value }}</span>
              </td>
              <td v-if="Object.keys(socialShown).length > 0">
                {{ socialShown["facebook"] }}
              </td>
              <td v-if="Object.keys(socialShown).length > 0">
                {{ socialShown["skype"] }}
              </td>
              <td v-if="Object.keys(socialShown).length > 0">
                {{ socialShown["instagram"] }}
              </td>
              <td v-if="Object.keys(socialShown).length > 0">
                {{ socialShown["linkdin"] }}
              </td>
              <td v-if="Object.keys(socialShown).length > 0">
                {{ socialShown["twitter"] }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <button
      class="close-btn"
      v-if="showHide"
      @click="
        showHide = 0;
        shownItem = [];
        socialShown = [];
      "
    >
      X
    </button>
  </div>
</template>

<script>
import axios from "axios";
import store from "@/store";
import router from "@/router";

export default {
  name: "table-component",
  props: {
    titles: Array,
    data: [],
    pageUrl: String,
    title: String,
    deleteApi: String,
    EditUrl: String,
  },
  data() {
    return {
      shownItem: [],
      socialShown: [],
      showHide: 0,
      titlesNo: [
        "social_media",
        "updated_at",
        "created_at",
        "socialmedia_id",
        "website_id",
        "video",
        "user_id",
      ],
    };
  },
  methods: {
    itemDelete(id) {
      const token = window.sessionStorage.getItem("token");
      axios
        .post(
          `${store.state.server}${this.deleteApi}/${id}`,
          {}, // Pass an empty object for the data
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          if (response.status === 200) {
            location.reload();
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
    itemUpdate(item) {
      store.state.Data = item;
      router.push(this.EditUrl);
    },
  },
};
</script>

<style>
.PopUp {
  position: fixed; /* Ensures it's relative to the viewport */
  top: 0;
  left: 0;
  height: 100vh; /* Replace 100dvh for wider compatibility */
  width: 100vw; /* Replace 100dvw for wider compatibility */
  backdrop-filter: blur(5px); /* Blurs content behind the pop-up */
  z-index: 1000; /* Ensures it's above other elements */
  display: flex;
  justify-content: center;
  align-self: center;
}

.close-btn {
  position: fixed;
  right: 30px;
  top: 30px;
  background-color: crimson;
  color: white;
  font-size: 40px;
  font-weight: 800;
  border-radius: 40%;
  z-index: 1001;
}

.imageTable {
  height: 300px;
  width: fit-content;
}
</style>
